module.exports = __webpack_public_path__ + "img/comparethemarketcarfinance.49d23019.svg";